export default __webpack_public_path__ + "static/media/ssoicon.f0cc761c.svg";